import { createApiClient } from "./apiClient";
import {config} from "../config";

const apiClient = createApiClient({
    baseURL: config.bffUrl + '/api/',
});

/**
 * Get all available subscription plans
 */
export const fetchSubscriptionPlans = async () => {
    try {
        const response = await apiClient.get('subscription/plans');
        return response.data;
    } catch (err) {
        console.error('Error fetching subscription plans', err);
        throw err;
    }
};

/**
 * Get current organization's subscription
 */
export const fetchCurrentSubscription = async () => {
    try {
        const response = await apiClient.get('subscription/current');
        return response.data;
    } catch (err) {
        if (err.response?.status === 204) {
            return null; // No subscription
        }
        console.error('Error fetching current subscription', err);
        throw err;
    }
};

/**
 * Create Stripe checkout session
 */
export const createCheckoutSession = async (planId, extraSeats = 0, billingInterval = 'YEARLY') => {
    try {
        const response = await apiClient.post(`subscription/checkout?planId=${planId}&billingInterval=${billingInterval}&extraSeats=${extraSeats}`);
        return response.data;
    } catch (err) {
        console.error('Error creating checkout session', err);
        throw err;
    }
};

/**
 * Update purchased additional seats on the current organization's active subscription
 */
export const updateSeats = async (extraSeats) => {
    try {
        const response = await apiClient.patch(`subscription/seats?extraSeats=${extraSeats}`);
        return response.data;
    } catch (err) {
        console.error('Error updating seats', err);
        throw err;
    }
};

/**
 * Create manual subscription (trial/free)
 */
export const createManualSubscription = async (planId, notes = '') => {
    try {
        const response = await apiClient.post(`subscription/manual?planId=${planId}&notes=${encodeURIComponent(notes)}`);
        return response.data;
    } catch (err) {
        console.error('Error creating manual subscription', err);
        throw err;
    }
};

/**
 * Cancel subscription
 */
export const cancelSubscription = async (subscriptionId, immediate = false, reason = '') => {
    try {
        const response = await apiClient.post(
            `subscription/${subscriptionId}/cancel?immediate=${immediate}&reason=${encodeURIComponent(reason)}`
        );
        return response.data;
    } catch (err) {
        console.error('Error canceling subscription', err);
        throw err;
    }
};

/**
 * Create customer portal session
 */
export const createPortalSession = async (returnUrl) => {
    try {
        const response = await apiClient.post(`subscription/portal?returnUrl=${encodeURIComponent(returnUrl)}`);
        return response.data;
    } catch (err) {
        console.error('Error creating portal session', err);
        throw err;
    }
};

/**
 * Get Stripe products and prices
 */
export const fetchStripeProducts = async () => {
    try {
        const response = await apiClient.get('subscription/admin/stripe/products');
        return response.data;
    } catch (err) {
        console.error('Error fetching Stripe products', err);
        throw err;
    }
};

/**
 * Sync Stripe products to database
 */
export const syncStripeProducts = async () => {
    try {
        const response = await apiClient.post('subscription/admin/stripe/sync');
        return response.data;
    } catch (err) {
        console.error('Error syncing Stripe products', err);
        throw err;
    }
};

/**
 * Get invoices for current organization
 */
export const fetchInvoices = async () => {
    try {
        const response = await apiClient.get('subscription/invoices');
        return response.data;
    } catch (err) {
        console.error('Error fetching invoices', err);
        throw err;
    }
};
